import { format } from 'date-fns-tz';
import { API } from '../../api';
import { exportCSVData } from '../../common/exportCSVData';
import { DATE_FORMAT_CSV } from '../../commonConst';
import { ICreateNominationReadinessTrack } from './interface';

export const createNominationReadinessTrack = async (data: ICreateNominationReadinessTrack) => {
    const response = await API.fetch(`/nomination-readiness-tracks`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot create Nomination Readiness Track!`);
};

export const fetchNominationReadinessTracks = async (
    { pagination, sorter, filter, search, include, companyId = null }: any,
    signal?: AbortSignal | null
) => {
    const limit = pagination?.pageSize && pagination?.pageSize > 0 ? pagination.pageSize : 10;
    const offset = pagination?.current && pagination?.current > 0 ? (pagination.current - 1) * limit : 0;

    const path = `/nomination-readiness-tracks?${new URLSearchParams({
        offset: offset.toString(),
        limit: limit.toString(),
        ...(filter && { ...filter }),
        ...(sorter && {
            sortField: sorter.field,
            sortOrder: sorter.order,
        }),
        ...(search && { search }),
        ...(include && { include }),
        ...(companyId && { companyId }),
    })}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load list of sites!`);
};

export const exportNominationReadinessTracks = async ({ sorter, filter, search, include, companyId = null }: any, signal?: AbortSignal | null) => {
    const query = new URLSearchParams({
        format: 'csv',
        include,
        ...(filter && { ...filter }),
        ...(sorter && {
            sortField: sorter.field,
            sortOrder: sorter.order,
        }),
        ...(search && { search }),
        ...(include && { include }),
        ...(companyId && { companyId }),
    });

    const response = await API.fetch(`/nomination-readiness-tracks?${query}`, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'text/csv',
        },
    });

    const respBody: string = await response.text();

    if (response.ok) {
        const fileName = `nomination-readiness-tracks--${format(new Date(), DATE_FORMAT_CSV)}.csv`;
        exportCSVData(respBody, fileName);
    } else {
        const respBody: any = await response.json();
        throw new Error(respBody?.error?.message || `Cannot export data!`);
    }
};

export const confirmNominationReadinessTrack = async (trackId: string) => {
    const response = await API.fetch(`/nomination-readiness-tracks/${trackId}/confirm`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot confirm Nomination Readiness Track!`);
};

export const validateNominationReadinessTrack = async (nominationIds: string[]) => {
    const response = await API.fetch(`/nomination-readiness-tracks/validate`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ nominationIds }),
    });

    if (response.ok) {
        return null;
    }

    const respBody: any = await response.json();

    throw new Error(respBody?.error?.message || 'Nomination validation failed!');
};

export const deleteNominationReadinessTrack = async (trackId: string) => {
    const response = await API.fetch(`/nomination-readiness-tracks/${trackId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (response.ok) {
        return;
    }

    const respBody: any = await response.json();
    throw new Error(respBody?.error?.message || `Cannot delete Nomination Readiness Track!`);
};
